import React from 'react';
import { DisclaimerProps } from './ListingDisclaimer.types';
import { StyledDisclaimer } from './ListingDisclaimer.styles';
import { Text } from '@blueprint/ui';

const Disclaimer = ({ data }: DisclaimerProps) => {
    if (!data?.branch) {
        return null;
    }

    const {
        branch: { name }
    } = data;

    return (
        <StyledDisclaimer>
            <Text size="small">
                Property descriptions and related information displayed on this
                page are marketing materials provided by - {name}. Zoopla does
                not warrant or accept any responsibility for the accuracy or
                completeness of the property descriptions or related information
                provided here and they do not constitute property particulars.
                Please contact {name} for full details and further information.
            </Text>
        </StyledDisclaimer>
    );
};

export default Disclaimer;
